module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markWrong-fa3c50914a02e3ffa767f5ddfd5a6e9b.png";